export default function getQueryStringFromObject(obj, includeQuestionMark = true) {
  return (includeQuestionMark ? "?" : "") + Object.keys(obj).map((key) => `${key}=${obj[key]}`).join("&")
}
